import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const VideoUpload = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [tags, setTags] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);
  const videoRef = useRef();
  const thumbRef = useRef();
  const navigate = useNavigate();

  const handleVideoSelect = (e) => {
    const file = e.target.files[0];
    if (file) { setVideoFile(file); setStep(2); }
  };

  const handleThumbnail = (e) => {
    const file = e.target.files[0];
    if (file) { setThumbnail(file); setThumbnailPreview(URL.createObjectURL(file)); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!videoFile) return setError('Please select a video file');
    if (!title.trim()) return setError('Title is required');
    setUploading(true);
    setError('');
    const formData = new FormData();
    formData.append('video', videoFile);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('tags', tags);
    if (thumbnail) formData.append('thumbnail', thumbnail);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post('/api/videos/upload/', formData, {
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => { setProgress(Math.round((e.loaded * 100) / e.total)); }
      });
      if (res.data.success) { navigate(`/videos/${res.data.video_id}`); }
    } catch (err) {
      setError(err.response?.data?.error || 'Upload failed. Please try again.');
    }
    setUploading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f0f', color: '#fff', padding: '20px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '30px' }}>
          <button onClick={() => navigate('/videos')} style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: '20px' }}>←</button>
          <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '600' }}>🎬 Upload to XpertTube</h1>
        </div>

        {step === 1 && (
          <div onClick={() => videoRef.current.click()} style={{ border: '2px dashed #444', borderRadius: '12px', padding: '80px 40px', textAlign: 'center', cursor: 'pointer', background: '#1a1a1a' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>🎬</div>
            <h2 style={{ color: '#fff', marginBottom: '8px' }}>Drag and drop video files to upload</h2>
            <p style={{ color: '#aaa', marginBottom: '24px' }}>Your videos will be private until you publish them</p>
            <button style={{ background: '#3ea6ff', color: '#000', border: 'none', borderRadius: '20px', padding: '10px 24px', fontWeight: '600', cursor: 'pointer', fontSize: '14px' }}>Select Files</button>
            <p style={{ color: '#666', fontSize: '12px', marginTop: '16px' }}>MP4, WEBM, MOV supported • Max 50MB</p>
            <input ref={videoRef} type="file" accept="video/mp4,video/webm,video/quicktime" onChange={handleVideoSelect} style={{ display: 'none' }} />
          </div>
        )}

        {step === 2 && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: '24px' }}>
            <div>
              {error && (
                <div style={{ background: 'rgba(255,0,0,0.1)', border: '1px solid #ff4444', color: '#ff6b6b', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
                  {error}
                </div>
              )}
              {uploading && (
                <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px' }}>
                    <span style={{ color: '#aaa' }}>Uploading...</span>
                    <span style={{ color: '#3ea6ff' }}>{progress}%</span>
                  </div>
                  <div style={{ background: '#333', borderRadius: '4px', height: '4px' }}>
                    <div style={{ background: '#3ea6ff', height: '4px', borderRadius: '4px', width: `${progress}%`, transition: 'width 0.3s' }} />
                  </div>
                </div>
              )}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Title (required)</label>
                <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Add a title that describes your video" maxLength={100}
                  style={{ width: '100%', padding: '12px 14px', background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '15px', boxSizing: 'border-box', outline: 'none' }} />
                <div style={{ textAlign: 'right', color: '#666', fontSize: '12px', marginTop: '4px' }}>{title.length}/100</div>
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Description</label>
                <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Tell viewers about your video" rows={5} maxLength={1000}
                  style={{ width: '100%', padding: '12px 14px', background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical', outline: 'none' }} />
                <div style={{ textAlign: 'right', color: '#666', fontSize: '12px', marginTop: '4px' }}>{description.length}/1000</div>
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Tags (comma separated)</label>
                <input value={tags} onChange={e => setTags(e.target.value)} placeholder="e.g. funny, pakistan, news, vlog"
                  style={{ width: '100%', padding: '12px 14px', background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} />
              </div>
              {videoFile && (
                <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', color: '#aaa' }}>
                  📹 <strong style={{ color: '#fff' }}>{videoFile.name}</strong> — {(videoFile.size / 1024 / 1024).toFixed(1)}MB
                  <button onClick={() => { setVideoFile(null); setStep(1); }} style={{ float: 'right', background: 'none', border: 'none', color: '#ff4444', cursor: 'pointer', fontSize: '12px' }}>Remove</button>
                </div>
              )}
            </div>

            <div>
              <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: '12px', padding: '20px' }}>
                <h3 style={{ margin: '0 0 12px', fontSize: '15px', fontWeight: '600' }}>Thumbnail</h3>
                <p style={{ color: '#aaa', fontSize: '13px', marginBottom: '16px', lineHeight: '1.5' }}>Upload a picture that shows what's in your video.</p>
                {thumbnailPreview ? (
                  <div style={{ marginBottom: '12px' }}>
                    <img src={thumbnailPreview} alt="Thumbnail" style={{ width: '100%', borderRadius: '8px', aspectRatio: '16/9', objectFit: 'cover' }} />
                    <button onClick={() => { setThumbnail(null); setThumbnailPreview(null); }}
                      style={{ marginTop: '8px', background: 'none', border: '1px solid #444', color: '#aaa', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', width: '100%' }}>
                      Remove Thumbnail
                    </button>
                  </div>
                ) : (
                  <div onClick={() => thumbRef.current.click()}
                    style={{ border: '2px dashed #444', borderRadius: '8px', padding: '30px', textAlign: 'center', cursor: 'pointer', marginBottom: '12px' }}>
                    <div style={{ fontSize: '32px', marginBottom: '8px' }}>🖼️</div>
                    <p style={{ color: '#aaa', fontSize: '13px', margin: 0 }}>Upload thumbnail</p>
                    <p style={{ color: '#666', fontSize: '11px', margin: '4px 0 0' }}>JPG, PNG • Recommended 1280x720</p>
                  </div>
                )}
                <input ref={thumbRef} type="file" accept="image/jpeg,image/png,image/webp" onChange={handleThumbnail} style={{ display: 'none' }} />
                <div style={{ marginTop: '24px', borderTop: '1px solid #333', paddingTop: '20px' }}>
                  <button onClick={handleSubmit} disabled={uploading || !videoFile || !title.trim()}
                    style={{ width: '100%', padding: '12px', background: uploading || !videoFile || !title.trim() ? '#333' : '#3ea6ff', color: uploading || !videoFile || !title.trim() ? '#666' : '#000', border: 'none', borderRadius: '20px', fontWeight: '600', cursor: uploading || !videoFile || !title.trim() ? 'not-allowed' : 'pointer', fontSize: '14px', marginBottom: '10px' }}>
                    {uploading ? `Uploading ${progress}%...` : '🚀 Publish Video'}
                  </button>
                  <button onClick={() => navigate('/videos')}
                    style={{ width: '100%', padding: '12px', background: 'none', color: '#aaa', border: '1px solid #444', borderRadius: '20px', cursor: 'pointer', fontSize: '14px' }}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoUpload;
